<template>
  <div class="row">
    <div v-if="step === 'uploadId'" class="steps">
      <div class="step-rounded enabled">
        <p class="step-num">1</p>
        <p class="step-name">Upload ID</p>
      </div>

      <div class="step-rounded disabled">
        <p class="step-num">2</p>
        <p class="step-name">Upload selfie</p>
      </div>
    </div>
    <div v-else class="steps">
      <div class="step-rounded passed">
        <p class="step-num">
          <img src="/resources/img/green_check.png" alt="" width="23" height="23" />
        </p>
        <p class="step-name">Upload ID</p>
      </div>

      <div class="step-rounded enabled">
        <p class="step-num">2</p>
        <p class="step-name">Upload selfie</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { IdVerificationStep } from "@/IdVerification/types";

export default Vue.extend({
  props: {
    step: {
      type: String as PropType<IdVerificationStep>,
      required: true,
    },
  },
});
</script>
